import SettingsPageHeader from "@/components/molecules/SettingsPageHeader";
import { More, Add } from "iconsax-react";

export interface Role {
  id: number;
  role: string;
  access: string;
  usersAssigned: number;
}

const RoleTableRows = ({ role }: { role: Role }) => {
  return (
    <tr className=" hover:bg-dark-6">
      <td className="px-6 py-4 text-dark-text font-medium">{role.role}</td>
      <td className="px-6 py-4 text-dark-text">{role.access}</td>
      <td className="px-6 py-4 text-dark-text">{role.usersAssigned}</td>
      <td className="px-6 py-4 text-dark-text">
        <button className="text-dark-100 hover:text-dark-text transition-colors p-1">
          {/* Action Icon */}
          <More className="w-6 h-6" color="#EEEEEE" />
        </button>
      </td>
    </tr>
  );
};

const ROLE_TABLE_HEADERS = ["Role", "Access Level", "Users Assigned", ""];

const roles: Role[] = [
  { id: 1, role: "Super Admin", access: "General access", usersAssigned: 2 },
  {
    id: 2,
    role: "Moderator",
    access: "Dashboard, User management, Group management",
    usersAssigned: 4,
  },
  { id: 3, role: "Finance Admin", access: "Finance", usersAssigned: 2 },
];

const AddRoleButton = () => {
  return (
    <button className="bg-dark-text text-black px-4 py-2 rounded-[5px] transition-colors flex items-center justify-center gap-2">
      <Add size={20} color="#000" />
      <p>Add Role</p>
    </button>
  );
};

const Roles = () => {
  return (
    <div>
      <SettingsPageHeader title="Roles & Permissions" />
      <div>
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-dark-10">
              <tr>
                {ROLE_TABLE_HEADERS.map((header) => (
                  <th
                    key={header}
                    className="px-6 py-4 text-left text-sm font-medium text-dark-100"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="">
              {roles.map((role) => (
                <RoleTableRows key={role.id} role={role} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-4 ">
        <AddRoleButton />
      </div>
    </div>
  );
};

export default Roles;
